module.exports = __webpack_public_path__ + "media/student_contributors/08CherishRecera-6f7d47e9.png";